'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CtaBlockProps {
  onBook: () => void;
  label?: string;
}

export default function CtaBlock({ onBook, label = 'Book Your Detail' }: CtaBlockProps) {
  return (
    <div
      className="my-4 rounded-2xl px-8 py-12 flex flex-col md:flex-row items-center justify-between gap-6"
      style={{
        background: 'linear-gradient(135deg, rgba(45,95,154,0.12) 0%, rgba(45,95,154,0.04) 100%)',
        border: '1px solid rgba(45,95,154,0.2)',
      }}
    >
      <div>
        <p className="mono text-[10px] tracking-widest uppercase mb-2" style={{ color: '#2D5F9A' }}>
          Fully Mobile Service
        </p>
        <p className="text-xl md:text-2xl font-semibold text-off-white">
          We come to you — no drop-off needed.
        </p>
        <p className="text-sm mt-1" style={{ color: 'rgba(168,169,173,0.6)' }}>
          Book online or call us. We&apos;ll handle the rest.
        </p>
      </div>
      <button
        onClick={onBook}
        className="btn-sapphire flex items-center gap-3 px-8 py-4 rounded-full mono text-[11px] font-semibold tracking-widest uppercase text-white whitespace-nowrap"
      >
        <Icon name="CalendarDaysIcon" size={16} variant="outline" />
        {label}
      </button>
    </div>
  );
}